<template>
  <div>
    <div class="layout-sidebar-section">
      <div
        class="layout-sidebar-section-title"
        @click="$emit('toggleSection', 'smartObjectAndBackgroundSection')"
      >
        <strong>SmartObject & Background</strong>
        <b-icon :icon="isOpen.smartObjectAndBackgroundSection ? 'chevron-up' : 'chevron-down'" />
      </div>
      <transition>
        <b-collapse :visible="isOpen.smartObjectAndBackgroundSection">
          <div>
            <div class="smart-object-ui-container">
              <div>
                <b-form-group
                  id="select-smart-object"
                  label="Smart Object"
                  label-for="select-smart-object"
                >
                  <b-form-select
                    id="select-smart-object"
                    v-model="selectedSmartObjectFieldId"
                    :options="smartObjectsList"
                    text-field="name"
                    value-field="id"
                    @change="onSelectSmartObject"
                  />
                </b-form-group>
              </div>
              <b-form-checkbox
                v-model="smartObjectData.showBackground"
                :inline="true"
                aria-label="show"
                class="mb-2"
                @change="onChange('showBackground', $event)"
              >
                Show background
              </b-form-checkbox>
            </div>
          </div>
        </b-collapse>
      </transition>
    </div>
    <PositionAndSize
      v-if="smartObjectFabricRectangleObject"
      :aspect-ratio-option="false"
      :h="(smartObjectFabricRectangleObject.height * smartObjectFabricRectangleObject.scaleY)"
      :w="(smartObjectFabricRectangleObject.width * smartObjectFabricRectangleObject.scaleX)"
      :x="parseFloat(smartObjectFabricRectangleObject.left)"
      :y="parseFloat(smartObjectFabricRectangleObject.top)"
      :is-open="isOpen"
      @toggleSection="toggleSectionHandler"
      @input="onChange"
    />
    <div class="layout-sidebar-section">
      <div
        class="layout-sidebar-section-title"
        @click="$emit('toggleSection', 'generalSettingsSection')"
      >
        <strong>General Settings</strong>
        <b-icon :icon="isOpen.generalSettingsSection ? 'chevron-up' : 'chevron-down'" />
      </div>
      <transition>
        <b-collapse :visible="isOpen.generalSettingsSection">
          <div>
            <b-form-group
              v-for="(setting, key) in option5FilteredSettings"
              :id="key"
              :key="key"
              class="mb-1"
            >
              <template #label>
                <div
                  class="d-flex"
                  :style="key === 'shadow' ? 'gap: 0px' : 'gap: 8px'"
                >
                  <div v-if="key === 'shadow'">
                    <b-form-checkbox
                      v-model="smartObjectData.showShadow"
                      :inline="true"
                      aria-label="show"
                      class="mr-0 pr-0 pb-1"
                      @change="onChange()"
                    >
                      {{ getSettingKeyName(key) + ' Setting' }}
                    </b-form-checkbox>
                  </div>
                </div>
              </template>

              <SkewForm
                v-if="key === 'skew' && setting && setting?.value"
                :tl="[setting.value[0], setting.value[1]]"
                :tr="[setting.value[2], setting.value[3]]"
                :br="[setting.value[4], setting.value[5]]"
                :bl="[setting.value[6], setting.value[7]]"
                :is-render="setting?.render"
                @change="onChange('skew', $event)"
              />
              <WarpForm
                v-else-if="key === 'warp' && setting && setting?.value"
                :is-render="setting?.render"
                :show-grid="setting?.showGrid"
                :editing="setting?.editing"
                @change="onChange('warp', $event)"
              />
              <div
                v-else
              >
                <template v-if="key !== 'shadow' || setting.enabled">
                  <b-form-row
                    v-for="(settingKey) in getKeys(setting)"
                    :key="settingKey"
                    class="ml-1"
                  >
                    <b-col
                      cols="3"
                    >
                      <label
                        :for="'input-' + settingKey"
                      >
                        {{ settingKey.charAt(0).toUpperCase() + settingKey.slice(1) }}
                      </label>
                    </b-col>
                    <b-col
                      cols="9"
                    >
                      <b-row>
                        <b-col class="pl-0">
                          <b-form-input
                            :id="'input-range-' + settingKey"
                            v-model="smartObjectData[settingKey]"
                            :max="rules[settingKey].max"
                            :min="rules[settingKey].min"
                            :step="rules[settingKey].step"
                            type="range"
                            :disabled="!checkIsSettingEnabled(setting)"
                            @input="onChange(settingKey, $event)"
                          />
                        </b-col>
                        <b-col
                          class="m-0 pl-0"
                          cols="4"
                        >
                          <b-form-input
                            :id="'input-' + settingKey"
                            v-model="smartObjectData[settingKey]"
                            :max="rules[settingKey].max"
                            :min="rules[settingKey].min"
                            :step="rules[settingKey].step"
                            :disabled="!checkIsSettingEnabled(setting)"
                            type="number"
                            @change="onChange(settingKey, $event)"
                          />
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-form-row>
                </template>
              </div>
            </b-form-group>
          </div>
        </b-collapse>
      </transition>
    </div>
    <div class="layout-sidebar-section">
      <div
        class="layout-sidebar-section-title"
        @click="$emit('toggleSection', 'membersSection')"
      >
        <strong>Members</strong>
        <b-icon :icon="isOpen.membersSection ? 'chevron-up' : 'chevron-down'" />
      </div>
      <transition>
        <b-collapse :visible="isOpen.membersSection">
          <div>
            <b-form-group
              id="members"
            >
              <img
                v-if="hoveredItem !== 'data:,'"
                :src="hoveredItem"
                alt="empty"
                class="member-thumbnail"
              >
              <div class="d-flex flex-column members-container">
                <b-form-checkbox
                  v-for="object in fieldsOptions"
                  :id="object.value + '_checkbox'"
                  :key="object.value"
                  :checked="object.isMember"
                  :inline="true"
                  :name="object.value + '_checkbox'"
                  class="member-item"
                  @change="updateAdditionalFieldsMembers(object.value)"
                >
                  <p
                    @mouseenter="hoveredItem = object.thumbnail"
                    @mouseleave="hoveredItem = 'data:,'"
                  >
                    {{ object.name }}
                    <b-icon
                      v-if="object.isText"
                      v-b-tooltip.hover.viewport.noninteractive="'Edit Text'"
                      icon="pencil"
                      class="ml-1"
                      @mousedown.stop.prevent
                      @click.stop.prevent="setActiveObject(object)"
                    />
                  </p>
                </b-form-checkbox>
                <b-form-checkbox
                  v-for="object in additionalFields"
                  :id="object.value + '_checkbox'"
                  :key="object.value"
                  :checked="object.isMember"
                  :inline="true"
                  :name="object.value + '_checkbox'"
                  class="member-item"
                  @change="updateAdditionalFieldsMembers(object.id)"
                >
                  <p
                    @mouseenter="hoveredItem = object.thumbnail"
                    @mouseleave="hoveredItem = 'data:,'"
                  >
                    {{ object.name }}
                    <b-icon
                      v-if="object.isText"
                      v-b-tooltip.hover.viewport.noninteractive="'Edit Text'"
                      icon="pencil"
                      class="ml-1"
                      @mousedown.stop.prevent
                      @click.stop.prevent="setActiveObject(object)"
                    />
                  </p>
                </b-form-checkbox>
              </div>
            </b-form-group>
          </div>
        </b-collapse>
      </transition>
    </div>
    <!--    <b-btn-->
    <!--      variant="primary"-->
    <!--      @click="onSave('save', null)"-->
    <!--    >-->
    <!--      Save-->
    <!--    </b-btn>-->
    <!--    <b-btn-->
    <!--      variant="outline-primary"-->
    <!--      @click="onCancel"-->
    <!--    >-->
    <!--      Cancel-->
    <!--    </b-btn>-->
    <div class="layout-sidebar-section">
      <div
        class="layout-sidebar-section-title"
        @click="$emit('toggleSection', 'actionSection')"
      >
        <strong>Actions</strong>
        <b-icon :icon="isOpen.actionSection ? 'chevron-up' : 'chevron-down'" />
      </div>
      <transition>
        <b-collapse :visible="isOpen.actionSection">
          <div>
            <div
              class="shape-editor-actions d-flex mb-3"
              style="grid-gap: 0.2rem;"
            >
              <button
                v-b-tooltip.hover
                title="Scale to template size"
                @click="onChange('scaleToTemplateSize')"
              >
                <img
                  src="/img/icons/full-screen.svg"
                >
              </button>
              <button
                v-b-tooltip.hover
                title="Center in template"
                @click="onChange('centerToTemplateSize')"
              >
                <img
                  src="/img/icons/center-image.svg"
                  alt="center-icon"
                >
              </button>
              <button
                v-b-tooltip.hover
                title="Center Horizontally"
                @click="onChange('centerToTemplateWidth')"
              >
                <img
                  src="/img/icons/align-center.png"
                  alt="align-center-icon"
                >
              </button>
              <button
                v-b-tooltip.hover
                title="Center Vertically"
                @click="onChange('centerToTemplateHeight')"
              >
                <img
                  src="/img/icons/vertical-alignment.png"
                  alt="align-center-icon"
                >
              </button>
              <button
                v-b-tooltip.hover
                title="Set to half of canvas width"
                @click="onChange('setToHalfOfCanvasWidth')"
              >
                <img
                  src="/img/icons/panel-left.svg"
                  alt="panel-left-icon"
                >
              </button>
            </div>
          </div>
        </b-collapse>
      </transition>
    </div>
    <b-btn
      variant="danger"
      @click="onDelete"
    >
      Delete Smart Object
    </b-btn>
    <b-button
      v-b-tooltip.hover
      :title="lockedState ? 'Unlock' : 'Lock'"
      variant="outline-primary"
      @click.stop="lockedState = !lockedState"
    >
      <b-icon :icon="lockedState ? 'lock-fill' : 'unlock'" />
    </b-button>
  </div>
</template>

<script>
import PositionAndSize from "./components/PositionAndSize.vue";
import {
  ADDITIONAL_BACKGROUND_THEME_IMAGE_PREFIX_ID,
  ADDITIONAL_CIRCLE_PREFIX_ID,
  ADDITIONAL_LINE_PREFIX_ID,
  ADDITIONAL_MULTI_LINE_TEXT_FIELD_PREFIX_ID,
  ADDITIONAL_RECTANGLE_PREFIX_ID,
  ADDITIONAL_TEXT_PREFIX_ID,
  BACKGROUND_COLOR_PREFIX_ID,
  MASK_PREFIX_ID
} from "@frontend/constants/templates-field-prefixes";
import SkewForm from "@frontend/components/modules/layouts-page/EditorControl/components/SkewForm.vue";
import {makeSmartObjectShadow, SMART_OBJECT_BACKGROUND_COLOR} from "@/common/preview/draw-smart-object";
import WarpForm from "@frontend/components/modules/layouts-page/EditorControl/components/WarpForm.vue";
import { FIELD_TYPE_TEXT, FIELD_TYPE_TEXT_OPTIONS, FIELD_TYPE_TEXT_FROM_SPREADSHEET, FIELD_TYPE_MULTI_LINE_TEXT, FIELD_TYPE_STATIC_TEXT } from "@frontend/constants/type-fields-of-template";

const ADD_FIELD_PREFIXES = [
  ADDITIONAL_BACKGROUND_THEME_IMAGE_PREFIX_ID,
  ADDITIONAL_MULTI_LINE_TEXT_FIELD_PREFIX_ID,
  ADDITIONAL_TEXT_PREFIX_ID,
  ADDITIONAL_RECTANGLE_PREFIX_ID,
  ADDITIONAL_CIRCLE_PREFIX_ID,
  ADDITIONAL_LINE_PREFIX_ID,
];
export default {
  components: {
    WarpForm,
    SkewForm,
    PositionAndSize,
  },
  props: {
    smartObjectsList: {
      type: Array,
      default: () => []
    },
    target: {
      type: Object,
      default: () => {
      },
    },
    options: {
      type: Object,
      default: () => {
      },
    },
    preview: {
      type: Object,
      default: () => {
      },
    },
    smartObjectId: {
      type: [String, Number],
      default: null,
    },
    isOpen: {
      type: Object,
      default: () => ({
        actionSection: true,
        membersSection: true,
        smartObjectAndBackgroundSection: true,
        generalSettingsSection: true,
      }),
    },
  },
  data() {
    return {
      lockedState: false,
      hoveredItem: 'data:,',
      selectedSmartObjectFieldId: null,
      members:[],        
      additionalFieldsMembers: [],        
      smartObjectFabricRectangleObject: null,
      nonEditableKeys: ['type', 'projection', 'spread', 'hskew', 'vskew', 'color', 'enabled'],
      smartObjectData: {
        angle: 0,
        distance: 0,
        opacity: 0,
        size: 0,
        radius: 0,
        showBackground: true,
        showShadow: true
      },
      rules:{
        angle: {
          min: 0,
          max: 360,
          step: 1
        },
        distance: {
          min:-200,
          max: 200,
          step: 1
        },
        opacity: {
          min: 0,
          max: 100,
          step: 1
        },
        size: {
          min: 0,
          max: 999,
          step: 1
        },
        radius: {
          min: 0,
          max: 999,
          step: 1
        },
      },
      backupSizeAndPosition: null,
      selectedMembers: [],
      isObjectChanged: false,
      settingsListExceptionKeys: ['showBackground'],
      overrideKeyNames: {
        'warp': 'Wrap',
      },
      fieldsOptions: [],
      additionalFields: [],
    }
  },
  computed:{
    option5() {
      if (!this.selectedSmartObjectFieldId || !this.smartObjectsList.length || !this.smartObjectFabricRectangleObject) {
        return {};
      }

      const { options: parsedOptionsFromObject }  = this.smartObjectFabricRectangleObject;
      const parsedOption5 = parsedOptionsFromObject;

      parsedOption5.skew = this.smartObjectFabricRectangleObject.skew;
      parsedOption5.warp = this.smartObjectFabricRectangleObject.warp;

      if (!_.isBoolean(parsedOption5.shadow.enabled)) {
        parsedOption5.shadow.enabled = true;
      }

      return parsedOption5;
    },
    option5FilteredSettings() {
      return Object.fromEntries(
          Object.entries(this.option5).filter(([key]) => !this.settingsListExceptionKeys.includes(key))
      );
    }
  },
  watch: {
    smartObjectId: function (newVal, oldVal) {
      this.selectedSmartObjectFieldId = newVal;
      this.selectSmartObject();
    },
  },
  mounted() {
    if (!this.selectedSmartObjectFieldId && this.smartObjectsList.length) {
      if (this.smartObjectId) {
        this.selectedSmartObjectFieldId = this.smartObjectsList.find(item => item.id == this.smartObjectId)?.id;
      }
      if (!this.selectedSmartObjectFieldId) {
        this.selectedSmartObjectFieldId = this.smartObjectsList[0].id;
      }
      this.selectSmartObject();
    }
  },
  
  methods: {
    setActiveObject (object) {
      this.preview.canvas.setActiveObject(object.obj);
      this.$emit('focus-textarea');
    },
    buildFieldsOptions() {
      if (!this.smartObjectFabricRectangleObject) return [];
      this.fieldsOptions = this.preview.canvas.getObjects()
        .filter(object => !!object.fieldId && ![MASK_PREFIX_ID, BACKGROUND_COLOR_PREFIX_ID].some(prefix => object.id.startsWith(prefix)))
        .map((obj) => {
          const field = this.preview.template.fields.find(field => field.id == obj.fieldId);
          const isText = [
            FIELD_TYPE_TEXT,
            FIELD_TYPE_TEXT_OPTIONS,
            FIELD_TYPE_TEXT_FROM_SPREADSHEET,
            FIELD_TYPE_MULTI_LINE_TEXT,
            FIELD_TYPE_STATIC_TEXT,
          ].includes(field?.type);
          return {
            value: ''+obj.fieldId,
            text: obj.id,
            groupName: obj?.groupName,
            thumbnail:
              obj.toDataURL('image/jpeg', 0.2),
            name: field.name,
            isMember: this.additionalFieldsMembers.includes(''+obj?.fieldId),
            isText,
            obj,
          }
        });
    },
    buildAdditionalFields() {
      const addObjects = this.preview.canvas.getObjects().filter(object => !!object?.id && ADD_FIELD_PREFIXES.some(prefix => object.id.startsWith(prefix))).filter(object => {
        if (object.id.startsWith(ADDITIONAL_BACKGROUND_THEME_IMAGE_PREFIX_ID)) {
          return !! object._element;
        }

        return true;
      })

      this.additionalFields = addObjects.map((obj) => ({
        id: obj.id,
        elementId: obj?.element_id,
        value: '' + obj.id,
        text: obj.name,
        groupName: obj?.groupName,
        thumbnail:
          obj.toDataURL('image/jpeg', 0.2),
        name: obj?.name || `none name - ${obj.id}`,
        isMember: this.additionalFieldsMembers.includes(obj?.id),
        isText: obj.id.startsWith(ADDITIONAL_TEXT_PREFIX_ID) || obj.id.startsWith(ADDITIONAL_MULTI_LINE_TEXT_FIELD_PREFIX_ID),
        obj,
      }));
    },
    getSettingKeyName(key) {
      const overrideName = this.overrideKeyNames[key];
      return overrideName ?? (key.charAt(0).toUpperCase() + key.slice(1));
    },
    toggleSectionHandler(sectionKey) {
      this.$emit('toggleSection', sectionKey);
    },
    selectSmartObject() {
      this.onSelectSmartObject();
      const { angle, distance, opacity, size, enabled: shadowEnabled } = this.option5.shadow
      const { radius } = this.option5.mask
      this.smartObjectData.angle = angle;
      this.smartObjectData.distance = distance;
      this.smartObjectData.opacity = opacity;
      this.smartObjectData.size = size;
      this.smartObjectData.radius = radius;
      this.smartObjectData.showShadow = shadowEnabled ?? true;
      this.smartObjectData.showBackground = this.option5.showBackground ?? true;
      this.buildFieldsOptions();
      this.buildAdditionalFields();
    },
    updateMembers(fieldId) {
      if (this.members.includes(fieldId)) {
        this.members = this.members.filter(member => member !== fieldId);
        return
      }
      this.members.push(fieldId);
    },
    updateAdditionalFieldsMembers(id) {
      if (this.additionalFieldsMembers.includes(id) || this.fieldsOptions.includes(id)) {
        this.preview.canvas.getObjects().filter(object => object.id + '' === id || object.fieldId+'' === id).map(object => {
          object.groupName = null;
        })
        this.additionalFieldsMembers = this.additionalFieldsMembers.filter(member => member !== id);
        this.smartObjectFabricRectangleObject.removeMember(id);
      } else {
        this.preview.canvas.getObjects().filter(object => object.id + '' === id || object.fieldId+'' === id).map(object => {
          object.groupName = this.smartObjectFabricRectangleObject.groupName;
        })
        this.additionalFieldsMembers.push(id);
        this.smartObjectFabricRectangleObject.addMember(id);
      }

      this.smartObjectFabricRectangleObject.canvas.renderAll()
    },
    getKeys(setting) {
      return Object.keys(setting).filter(key => !this.nonEditableKeys.includes(key));
    },
    // onCancel() {
    //   this.smartObjectFabricRectangleObject.cancelChanges();
    //   this.selectSmartObject();
    // },
    async onDelete() {
      await this.smartObjectFabricRectangleObject.deleteLayer(this.smartObjectFabricRectangleObject.canvas.instance_id);
    },
    onChange(action = null, value = null) {
      switch (action) {
        case 'x':
          this.smartObjectFabricRectangleObject.setPositionByOrigin(
            {
              ...this.smartObjectFabricRectangleObject.getPointByOrigin('left', 'top'),
              x: parseFloat(value)
            }, 'left', 'top')
          break
        case 'y':
          this.smartObjectFabricRectangleObject.setPositionByOrigin(
            {
              ...this.smartObjectFabricRectangleObject.getPointByOrigin('left', 'top'),
              y: parseFloat(value)
            }, 'left', 'top')
          break
        case 'w':
          this.smartObjectFabricRectangleObject.set({
            width: parseFloat(value),
            scaleX: 1
          });
          break
        case 'h':
          this.smartObjectFabricRectangleObject.set({
            height: parseFloat(value),
            scaleY: 1
          });
          break
        case 'skew':
          this.smartObjectFabricRectangleObject.set('skew', value);
          break;
        case 'warp':
          this.smartObjectFabricRectangleObject.set({
            warp: {
              ...this.smartObjectFabricRectangleObject.warp,
              render: value.render,
              showGrid: value.showGrid,
              editing: value.editing
            }
          });
          break;
        case 'showBackground':
          if (value) {
            this.smartObjectFabricRectangleObject.set('fill', SMART_OBJECT_BACKGROUND_COLOR);
          } else {
            this.smartObjectFabricRectangleObject.set('fill', 'transparent');
          }
          break;
        case 'centerToTemplateWidth': {
          const zoom = this.smartObjectFabricRectangleObject.canvas.getZoom();
          const templateWidth = this.smartObjectFabricRectangleObject.canvas.width / zoom; 
          const smartObjectWidth = this.smartObjectFabricRectangleObject.width * this.smartObjectFabricRectangleObject.scaleX; 

          this.smartObjectFabricRectangleObject.centerH();
          const newLeft = (templateWidth - smartObjectWidth) / 2;
          
          this.smartObjectFabricRectangleObject.set({
            left: newLeft,
          });
          
          this.preview.canvas.renderAll();
          break;
        }
        case 'centerToTemplateHeight': {
          const zoom = this.smartObjectFabricRectangleObject.canvas.getZoom();
          const templateHeight = this.smartObjectFabricRectangleObject.canvas.height / zoom; 
          const smartObjectHeight = this.smartObjectFabricRectangleObject.height * this.smartObjectFabricRectangleObject.scaleY; 
          const newTop = (templateHeight - smartObjectHeight) / 2;
          
          this.smartObjectFabricRectangleObject.set({
            top: newTop,
          });
          
          this.preview.canvas.renderAll();
          break;
        }
        case 'centerToTemplateSize': {
          const zoom = this.smartObjectFabricRectangleObject.canvas.getZoom();
          const templateWidth = this.smartObjectFabricRectangleObject.canvas.width / zoom; 
          const smartObjectWidth = this.smartObjectFabricRectangleObject.width * this.smartObjectFabricRectangleObject.scaleX; 
          const templateHeight = this.smartObjectFabricRectangleObject.canvas.height / zoom; 
          const smartObjectHeight = this.smartObjectFabricRectangleObject.height * this.smartObjectFabricRectangleObject.scaleY;

          const newLeft = (templateWidth - smartObjectWidth) / 2;
          const newTop = (templateHeight - smartObjectHeight) / 2;

          this.smartObjectFabricRectangleObject.set({
            left: newLeft,
            top: newTop,
          });

          this.preview.canvas.renderAll();
          break;
        }
        case 'scaleToTemplateSize': {
          const zoom = this.smartObjectFabricRectangleObject.canvas.getZoom();
          const templateWidth = this.smartObjectFabricRectangleObject.canvas.width / zoom;
          const templateHeight = this.smartObjectFabricRectangleObject.canvas.height / zoom;
          const scaleByAspectRatio = templateWidth / this.smartObjectFabricRectangleObject.width
          const xCalc = ((scaleByAspectRatio - this.smartObjectFabricRectangleObject.scaleX) * this.smartObjectFabricRectangleObject.width) / 2
          const yCalc = ((scaleByAspectRatio - this.smartObjectFabricRectangleObject.scaleY) * this.smartObjectFabricRectangleObject.height) / 2
          const {x,y} = this.smartObjectFabricRectangleObject.getPointByOrigin('left', 'top')

          this.smartObjectFabricRectangleObject.set({
            top: y + yCalc,
            left: x + xCalc,
            scaleX: templateWidth / this.smartObjectFabricRectangleObject.width,
            scaleY: templateHeight / this.smartObjectFabricRectangleObject.height,
          });

          const smartObjectWidth = this.smartObjectFabricRectangleObject.width * this.smartObjectFabricRectangleObject.scaleX; 
          const smartObjectHeight = this.smartObjectFabricRectangleObject.height * this.smartObjectFabricRectangleObject.scaleY;
          const newLeft = (templateWidth - smartObjectWidth) / 2;
          const newTop = (templateHeight - smartObjectHeight) / 2;

          this.smartObjectFabricRectangleObject.set({
            left: newLeft,
            top: newTop,
          });

          this.preview.canvas.renderAll();
          break;
        }
        case 'setToHalfOfCanvasWidth': {
          const zoom = this.smartObjectFabricRectangleObject.canvas.getZoom();
          const templateWidth = this.smartObjectFabricRectangleObject.canvas.width / zoom;

          const targetWidth = templateWidth / 2;

          this.smartObjectFabricRectangleObject.set({
            scaleX: targetWidth / this.smartObjectFabricRectangleObject.width,
          });

          this.smartObjectFabricRectangleObject.setCoords();
          this.preview.canvas.renderAll();

          break;
        }
        default:
          break
      }
      this.smartObjectFabricRectangleObject.set(
        'shadow',
        this.smartObjectData.showShadow
          ? makeSmartObjectShadow({ ...this.smartObjectData })
          : null
      );
      this.smartObjectFabricRectangleObject.set('rx', parseFloat(this.smartObjectData.radius));
      this.smartObjectFabricRectangleObject.set('ry', parseFloat(this.smartObjectData.radius));
      this.smartObjectFabricRectangleObject.updateChanges({ ...this.smartObjectData } );
    },
    initMembers() {
      this.additionalFieldsMembers = [...this.smartObjectFabricRectangleObject.members]
    },
    onSelectSmartObject() {
      const relativeFabricObject = this.preview.canvas.getObjects()
        .find(object => object.fieldId ? object.fieldId == this.selectedSmartObjectFieldId : object.element_id == this.selectedSmartObjectFieldId);
      
      this.smartObjectFabricRectangleObject = relativeFabricObject;
      this.smartObjectFabricRectangleObject.isSelectedByUi = true;
      const {width, height, scaleX, scaleY} = this.smartObjectFabricRectangleObject;
      const {x,y} = this.smartObjectFabricRectangleObject.getPointByOrigin('left', 'top')
      this.smartObjectFabricRectangleObject.backupSizeAndPosition = {left: x, top: y, width: width * scaleX, height: height * scaleY};
      this.smartObjectFabricRectangleObject.isNeedHandleObjectMovingUpdate = false;
      if (!this.smartObjectFabricRectangleObject.evented && !this.smartObjectFabricRectangleObject.selectable) {
        this.smartObjectFabricRectangleObject.evented = true;
        this.smartObjectFabricRectangleObject.selectable = true;
      }
      this.lockedState = this.smartObjectFabricRectangleObject.locked;
      this.smartObjectFabricRectangleObject.set('locked', false);
      this.initMembers()
      this.preview.canvas.setActiveObject(relativeFabricObject);
      this.preview.canvas.renderAll();
    },
    checkIsSettingEnabled(setting) {
      return _.isBoolean(setting.enabled) ? setting.enabled : true;
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .layout-sidebar-section legend {
  padding-bottom: 0;
}

#members {
  position: relative;

  .members-container {
    max-height: 291px;
    overflow: auto;
    margin-left: 7px;

    .custom-checkbox {
      .custom-control-label {
        display: inline-flex;
        align-content: center;
        align-items: center;
        justify-content: flex-start;
      }
    }
    .member-item {
      max-width: max-content;
      left: 3px;
      p {
        margin: 0;
      }
    }
  }
  .member-thumbnail {
    position: absolute;
    right: 0;
    top: 0;
    width: 164px;
    height: 68px;
    object-fit: contain;
    object-position: top right;
  }
  &:hover{
    .member-thumbnail {
      display: block;
    }
  }
}

@media screen and (width: 1300px) and (height: 738px) {
  .smart-object-ui-container {
    overflow-y: hidden;
    overflow-x: hidden;
    height: 687px;
  }
  .smart-object-ui-container:hover {
    overflow-y: auto;
  }
}
</style>
